/* eslint-disable @typescript-eslint/no-explicit-any */
import { deepCopy } from '../../helpers';
import { BlueprintData6, UnknownBlueprint } from '../types';

export const u6 = (blueprint: UnknownBlueprint): BlueprintData6 => {
	console.log('schema-update:process-update:6:started');

	const newBlueprint = deepCopy(blueprint) as UnknownBlueprint & { state: any[] };
	try {
		newBlueprint.state.forEach((state) => {
			// remove saved KitchenSize by Angle - no longer persisted
			delete (state.kitchenSize.byAngle);
		});
	} catch (err) {
		console.error(err);
	}

	newBlueprint.schemaVersion = 6;
	console.log('schema-update:process-update:6:completed', newBlueprint);
	return newBlueprint as BlueprintData6;
};
